import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./AjaxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addAjaxToSite, addCamectAPI, addSigfoxAPI, aiboxLogin, ajaxLogin, checkhubLinks, getHubs, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PasswordInput from '../../../../Inputs/PasswordInput';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/newLoading.json'
import successAnim from '../../../../../../assets/animations/success.json'
import failAnim from '../../../../../../assets/animations/fail.json'
import { Dialog } from 'primereact/dialog';



const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const AjaxForm = ({ setShowVirtualSource, outputs, fetchVirtualSources }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to link AJAX Hub, please wait...")
    const [linkTitle, setLinkTitle] = useState("Logged in successfully!")
    const [loading, setLoading] = useState(false)

    const userID = useSelector(state => state.auth.userID);

    const [hubs, setHubs] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([])

    const [zoneName, setZoneName] = useState("")
    const [failReason, setFailReason] = useState("")

    const [loggingIn, setLoggingIn] = useState(false)
    const [failed, setFailed] = useState(false)

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      

    const [emailState, dispatchEmailState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const emailRef = useRef();
    const passwordRef = useRef();


    const emailChangeHandler = (event) => {
        dispatchEmailState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();
    };

    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    const checkAjaxHubLinks = async (hubs) => {
        const body = {
            hubIds: hubs.map(hub => hub.hubId)
        }
        
        const response = await checkhubLinks(apiData, body, dispatch)
        if (response.data.success){
            const linkedMap = response.data.linked
            const combined = hubs.map(hub => ({
                ...hub,
                linkedSiteId: linkedMap[hub.hubId] ?? null
            }));

            setHubs(combined)
        } else {
            setModalPageIndex(9)
            setFailReason("Failed to check existing links for AJAX Hubs")
        }

        //show hubs
        setModalPageIndex(5)

    }

    const getAjaxHubs = async () => {
        const response = await getHubs(apiData, dispatch)
        if (response.data.success){
            console.log(response);
            //check hub links
            setHubs(response.data.hubs)
            checkAjaxHubLinks(response.data.hubs);
        } else {
            setModalPageIndex(9)
            setFailReason("Failed retrieve AJAX Hub info")
        }
    }

    const HandleLogin = async () => {
        setMessage("") //reset 
        //setModalPageIndex(3)
        setLoggingIn(true)
        let loginBody = {
           ajaxEmail: emailState.value,
           ajaxPassword: passwordState.value,
           ajaxUserRole: "USER",
           userID: userID
        }

        const loginResponse = await ajaxLogin(apiData, loginBody, dispatch)
        if (loginResponse.data.success) {
            //get hubs
            setLoggingIn(false)
            setModalPageIndex(4)
            getAjaxHubs()
        } else {
            //setModalPageIndex(9)
            setLoggingIn(false)
            setFailed(true)
            setFailReason("Failed to login to AJAX, please check your credentials & try again")
        }
    }

    const HandleSelectHub = (hub) => {
        setSelectedHubs((prevSelectedHubs) => {
            const isAlreadySelected = prevSelectedHubs.some(
                (x) => x.hubId === hub.hubId
            );

            if (isAlreadySelected) {
                return [];
            }

            return [hub];
        });
    };

    const HandleLink = async () => {
        const body = {
            ajaxHubId: selectedHubs[0].hubId,
            siteUUID: DeviceUUID,
            pinNumber: String(pinSelected)
        }
        const response = await addAjaxToSite(apiData, body, dispatch)
        if (response.data.success){
            setModalPageIndex(8)
            fetchVirtualSources();
        } else {
            setFailed(true)
            //setModalPageIndex(9)
            setFailReason(`${response.data.message}`)
        }

    }

    useEffect(() => {
    },  [selectedHubs])

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={styles["container1"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which output would you like to link to?</h3>
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {outputs.map((output) => {
                                            return (
                                                <li key={output.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                        {output.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>AJAX Login</h2>
                            <p style={{color:"#6e6e6e"}}>Login to your account by completing the fields below</p>
                            <small style={{color:"#6e6e6e"}}>Please be aware that AJAX will lock you out of your account for 1 hour if you get the password wrong 3 times in a row.</small>
                            <br></br>
                            <br/>
                            {invalidIP && <small className={styles.errorMessage}>{invalidIP}</small>}

                            <input
                                placeholder={"Email"}
                                ref={emailRef}
                                id="email"
                                value={emailState.value}
                                onChange={emailChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <PasswordInput
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button  icon="pi pi-user" severity="info" type="submit" disabled={loading} onClick={HandleLogin}>
                                {loading ? "Logging in..." : "Log in"}
                            </Button>
                        </div>
                    </div>    
                   
                )

                HandleShowModal();
            break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button   icon="pi pi-times" severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )

                HandleShowModal();
            break; 
            case 3: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into AJAX</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;
            case 4: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Successfully logged in!</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Retrieving hub info, please wait...</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;

        case 5: 
            //Hubs
            setModalComponent( () =>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>{`Which AJAX Hub would you like to control/observe?`}</h3>
                    <br/>
                    <br/>
                    {hubs.length > 0 &&
                        hubs.map((hub, index) => (
                            <>
                            
                            <Button
                                key={index}
                                severity="secondary"
                                outlined={!selectedHubs.includes(hub)}
                                label={`${hub.hubId}`} 
                                style={{ marginBottom: "2px", width: "200px" }}
                                onClick={() => HandleSelectHub(hub)}
                                disabled={hub.linkedSiteId != null}
                            />
                            {hub.linkedSiteId != null && <small>{`Linked to ${hub.linkedSiteId}`}</small>}

                            <br/>
                            </>
                        ))
                    }
                    <br/>

                    <br/>
                    <Button
                        label={"Finish"} 
                        disabled={selectedHubs.length == 0}
                         icon="pi pi-check"
                        severity="success"   // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink()}
                    />
                
                </div>
            )

            HandleShowModal();
            break;
      
        
        case 8:
            //success
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>{`AJAX Hub linked successfully!`}</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <br></br>
                        <Button 
                            onClick={() => HandleCloseModal()} 
                            style={{ width: "100%" }}
                            severity='secondary'
                            label='Close'
                             icon="pi pi-times"
                        />
                    </div>
                </div>
            )
            HandleShowModal();
        break;
        case 9:
            //fail 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                 <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                  <br></br>
                  <br></br>
                  <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{failReason}</h3>
                  </div>
                  <br></br>
                  <br></br>
                  <div>
                    <br></br>
                    <Button  icon="pi pi-chevron-left" onClick={() => HandleNewLoginAttempt(true)} severity="info" label="Back to login" style={{ width: "100%" }}/>
                  </div>
                </div>
              )
            
            HandleShowModal();
        break; 
        
        }
    }, [modalPageIndex, emailState, passwordState, linkMessage, linkTitle, message, selectedHubs, failReason]);

    const HandleNewLoginAttempt = (state) => {
        if (state){
            setModalPageIndex(1)
        }
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Link AJAX Hub(s)"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>

            <Dialog
                header="Logging in"
                visible={loggingIn}
                style={{ width: "25vw" }}
                onHide={() => setLoggingIn(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into AJAX</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 250, height: 450, margin: "0px" }}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Failed"
                visible={failed}
                style={{ width: "25vw" }}
                onHide={() => setFailed(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Failed to login</h3>
                    <br/>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />

                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px", alignContent:"center", display:"flex"}}>{failReason}</p>
                    <br/>
                    <Button  icon="pi pi-times" label='Close' severity='secondary' onClick={() => setFailed(false)}/>
                </div>
            </Dialog>
        </>
    )
}

export default AjaxForm;